import React from "react";
import { useLanguage } from "../context/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQSection = () => {
  const { t } = useLanguage();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-padding bg-[#F8FAFC]"
    >
      <div className="container-page">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="chip mb-5">{t.faq.eyebrow}</span>
            <h2
              data-testid="faq-title"
              className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]"
            >
              {t.faq.title}
            </h2>
            <p className="mt-5 text-base text-foreground/70 leading-relaxed">
              Pour toute question spécifique, le secrétariat vous répond au{" "}
              <a
                href="tel:+33488600216"
                className="font-semibold text-[#FF5A1F] hover:underline"
              >
                +33 4 88 60 02 16
              </a>
              .
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {t.faq.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="text-left font-display font-semibold text-base md:text-lg text-navy hover:text-[#FF5A1F] py-5">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm md:text-base text-foreground/75 leading-relaxed pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
